import { httpsCallable } from 'firebase/functions';
import { functions } from '../constants/firebaseModular';
import type { CreatePatientPayload, CreatePatientResponse } from '@usacsmideo/types';

export const createPatient = async (payload: { uid: string; email: string }) => {
  const postToCloudFunction = httpsCallable<CreatePatientPayload, CreatePatientResponse>(
    functions,
    'createPatient',
  );

  const response = await postToCloudFunction({
    uid: payload.uid,
    email: payload.email,
    source: 'patient-portal',
  });

  console.log('createPatient success:', response.data.message);
  return response;
};
